/**
 * @generated SignedSource<<09a8e7ff8a3897baaaef1c8523add7d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransactionTypeEnum = "ACCEPT_OFFER" | "ACCEPT_SWAP" | "APPROVE_COLLECTION" | "ASSETS_RECEIVED" | "ASSETS_SENT" | "BRIDGE_DEPOSIT" | "BRIDGE_WITHDRAW" | "BULK_ACCEPT_OFFER" | "BULK_OFFER_ACCEPTED" | "BULK_PURCHASE" | "BULK_RECEIVED" | "BULK_SALE" | "BULK_SENT" | "BUY_NOW" | "CANCEL_ALL_ORDERS" | "CANCEL_ASK" | "CANCEL_BID" | "CANCEL_COLLECTION_OFFFER" | "CANCEL_ORDERS" | "CANCEL_SWAP" | "CONFIGURE_DROP" | "CREATE_SEADROP_CONTRACT" | "ERC20_APPROVE" | "ERC20_RECEIVED" | "ERC20_SENT" | "ERC20_SWAP_DEPOSIT" | "ERC20_SWAP_WITHDRAW" | "MINT" | "MINT_ALLOWLIST" | "NATIVE_RECEIVED" | "NATIVE_SENT" | "NFT_RECEIVED" | "NFT_SENT" | "OFFER_ACCEPTED" | "OPENSEA_PRO_TRADE" | "REDEEM" | "SALE" | "SWAP_COMPLETE" | "UNKNOWN" | "UNWRAP" | "WRAP" | "%future added value";
export type UserTransactionState = "CANCELING" | "CANCELLED" | "PENDING" | "REJECTED" | "REQUESTED" | "SUCCESSFUL" | "%future added value";
export type TransactionListQuery$variables = {
  address: string;
  chain: | "ETHEREUM" | "MATIC" | "KLAYTN" | "BSC" | "SOLANA" | "ARBITRUM" | "ARBITRUM_NOVA" | "AVALANCHE" | "OPTIMISM" | "OPTIMISM_SEPOLIA" | "AMOY" | "BAOBAB" | "BSC_TESTNET" | "SOLDEV" | "ARBITRUM_SEPOLIA" | "AVALANCHE_FUJI" | "SEPOLIA" | "BASE" | "BASE_SEPOLIA" | "ZORA" | "ZORA_SEPOLIA" | "ZORA_TESTNET"  | "FLOW" | "FLOW_TESTNET" | "BLAST_SEPOLIA" | "BLAST" | "GUNZILLA" | "GUNZILLA_TESTNET" | "SEI" | "SEI_TESTNET" | "B3_SEPOLIA" | "B3" |  "APE_CHAIN" | "APE_CURTIS" | "SONEIUM_MINATO" | "SONEIUM" | "RONIN" | "BERA_CHAIN" | "SHAPE" | "UNICHAIN" | "MONAD_TESTNET" | "SAIGON_TESTNET" | "ABSTRACT_TESTNET" | "%future added value";
  count: number;
};
export type TransactionListQuery$data = {
  readonly transactionHistory: ReadonlyArray<{
    readonly fromAddress: string;
    readonly metadata: {
      readonly type: TransactionTypeEnum;
      readonly " $fragmentSpreads": FragmentRefs<"Transaction_metadata">;
    } | null | undefined;
    readonly nonce: number;
    readonly receipt: {
      readonly status: boolean;
      readonly transactionHash: string;
      readonly " $fragmentSpreads": FragmentRefs<"Transaction_receipt">;
    } | null | undefined;
  }>;
  readonly userTransactions: ReadonlyArray<{
    readonly createdDate: string;
    readonly nonce: number;
    readonly relayId: string;
    readonly state: UserTransactionState | null | undefined;
    readonly transactionHash: string | null | undefined;
    readonly transactionMetadata: {
      readonly type: TransactionTypeEnum;
      readonly " $fragmentSpreads": FragmentRefs<"Transaction_metadata">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"Transaction_userTransaction">;
  }>;
};
export type TransactionListQuery = {
  response: TransactionListQuery$data;
  variables: TransactionListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "address"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chain"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  }
],
v1 = {
  "kind": "Variable",
  "name": "chain",
  "variableName": "chain"
},
v2 = {
  "kind": "Variable",
  "name": "fromAddress",
  "variableName": "address"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nonce",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fromAddress",
  "storageKey": null
},
v6 = [
  (v1/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionHash",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  (v9/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "Transaction_metadata"
  }
],
v11 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "states",
    "value": [
      "PENDING",
      "CANCELLED"
    ]
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relayId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayImageUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decimals",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usdSpotPrice",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenStandard",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ChainType",
  "kind": "LinkedField",
  "name": "chain",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v24 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetQuantityType",
    "kind": "LinkedField",
    "name": "sentAssetQuantities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetType",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v15/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/),
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetQuantityType",
    "kind": "LinkedField",
    "name": "receivedAssetQuantities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetType",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v15/*: any*/),
          (v20/*: any*/),
          (v18/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/),
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CollectionType",
    "kind": "LinkedField",
    "name": "collections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logo",
        "storageKey": null
      },
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  (v23/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AccountType",
    "kind": "LinkedField",
    "name": "recipient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      (v18/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BridgeMetadataType",
    "kind": "LinkedField",
    "name": "bridgeMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bridgeStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expectedBridgeCompletionTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aggregator",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TransactionHistoryType",
        "kind": "LinkedField",
        "name": "transactionHistory",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TransactionReceiptType",
            "kind": "LinkedField",
            "name": "receipt",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Transaction_receipt"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TransactionMetadataType",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "UserTransactionType",
        "kind": "LinkedField",
        "name": "userTransactions",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          (v7/*: any*/),
          (v4/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionMetadataType",
            "kind": "LinkedField",
            "name": "transactionMetadata",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Transaction_userTransaction"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TransactionHistoryType",
        "kind": "LinkedField",
        "name": "transactionHistory",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TransactionReceiptType",
            "kind": "LinkedField",
            "name": "receipt",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PriceType",
                "kind": "LinkedField",
                "name": "transactionFee",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usd",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TransactionMetadataType",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "UserTransactionType",
        "kind": "LinkedField",
        "name": "userTransactions",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          (v7/*: any*/),
          (v4/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionMetadataType",
            "kind": "LinkedField",
            "name": "transactionMetadata",
            "plural": false,
            "selections": (v24/*: any*/),
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da6d69baf12ba74295e6e3069ff3fd68",
    "id": null,
    "metadata": {},
    "name": "TransactionListQuery",
    "operationKind": "query",
    "text": "query TransactionListQuery(\n  $address: AddressScalar!\n  $chain: ChainScalar!\n  $count: Int!\n) {\n  transactionHistory(fromAddress: $address, chain: $chain, first: $count) {\n    nonce\n    fromAddress\n    receipt(chain: $chain) {\n      transactionHash\n      status\n      ...Transaction_receipt\n    }\n    metadata(chain: $chain) {\n      type\n      ...Transaction_metadata\n    }\n  }\n  userTransactions(fromAddress: $address, chain: $chain, states: [PENDING, CANCELLED]) {\n    relayId\n    transactionHash\n    nonce\n    state\n    createdDate\n    transactionMetadata {\n      type\n      ...Transaction_metadata\n    }\n    ...Transaction_userTransaction\n    id\n  }\n}\n\nfragment AcceptOffer_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment ApproveCollection_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment ApproveCollection_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment ApproveCurrency_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      symbol\n      ...PaymentAssetMedia_asset\n      id\n    }\n    id\n  }\n}\n\nfragment ApproveCurrency_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment BulkTransfer_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n}\n\nfragment BulkTransfer_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment CancelAllOrders_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment CancelDeal_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n}\n\nfragment CancelDeal_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment CancelOrder_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      displayName\n      tokenStandard\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      displayName\n      tokenStandard\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment CancelOrder_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment CollectionMedia_collection on CollectionType {\n  logo\n}\n\nfragment ConfigureDrop_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment ConfigureDrop_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment CreateDropTransaction_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment DealAccept_metadata on TransactionMetadataType {\n  type\n  sentAssetQuantities {\n    asset {\n      tokenStandard\n      decimals\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      tokenStandard\n      decimals\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment DealAccept_receipt on TransactionReceiptType {\n  fromAddress\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment Mint_metadata on TransactionMetadataType {\n  quantity\n  sentAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment OfferAccepted_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment PaymentAssetMedia_asset on AssetType {\n  displayImageUrl\n}\n\nfragment PaymentAssetTransfer_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      symbol\n      decimals\n      usdSpotPrice\n      ...PaymentAssetMedia_asset\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      symbol\n      decimals\n      usdSpotPrice\n      ...PaymentAssetMedia_asset\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment Purchase_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment Receive_metadata on TransactionMetadataType {\n  receivedAssetQuantities {\n    asset {\n      symbol\n      decimals\n      usdSpotPrice\n      ...PaymentAssetMedia_asset\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment Redeem_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment Redeem_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment Sale_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      displayName\n      ...StackedAssetMedia_assets\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment StackedAssetMedia_assets on AssetType {\n  displayImageUrl\n}\n\nfragment Swap_metadata on TransactionMetadataType {\n  bridgeMetadata {\n    bridgeStatus\n    expectedBridgeCompletionTime\n    aggregator\n  }\n  sentAssetQuantities {\n    asset {\n      decimals\n      symbol\n      chain {\n        identifier\n      }\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      decimals\n      symbol\n      chain {\n        identifier\n      }\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment Transaction_metadata on TransactionMetadataType {\n  type\n  ...AcceptOffer_metadata\n  ...OfferAccepted_metadata\n  ...DealAccept_metadata\n  ...ApproveCollection_metadata\n  ...ApproveCurrency_metadata\n  ...BulkTransfer_metadata\n  ...CancelOrder_metadata\n  ...CancelDeal_metadata\n  ...PaymentAssetTransfer_metadata\n  ...Purchase_metadata\n  ...Sale_metadata\n  ...Mint_metadata\n  ...Transfer_metadata\n  ...Unwrap_metadata\n  ...Wrap_metadata\n  ...Redeem_metadata\n  ...ConfigureDrop_metadata\n  ...Swap_metadata\n  ...Receive_metadata\n}\n\nfragment Transaction_receipt on TransactionReceiptType {\n  status\n  transactionHash\n  ...ApproveCollection_receipt\n  ...ApproveCurrency_receipt\n  ...DealAccept_receipt\n  ...BulkTransfer_receipt\n  ...CancelAllOrders_receipt\n  ...CancelDeal_receipt\n  ...CancelOrder_receipt\n  ...Transfer_receipt\n  ...CreateDropTransaction_receipt\n  ...UnknownTransaction_receipt\n  ...Redeem_receipt\n  ...ConfigureDrop_receipt\n}\n\nfragment Transaction_userTransaction on UserTransactionType {\n  nonce\n  transactionHash\n  state\n  createdDate\n}\n\nfragment Transfer_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      ...StackedAssetMedia_assets\n      id\n    }\n    id\n  }\n  recipient {\n    address\n    id\n  }\n}\n\nfragment Transfer_receipt on TransactionReceiptType {\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment UnknownTransaction_receipt on TransactionReceiptType {\n  fromAddress\n  transactionFee {\n    unit\n    symbol\n    usd\n  }\n}\n\nfragment Unwrap_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      symbol\n      decimals\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      ...PaymentAssetMedia_asset\n      id\n    }\n    id\n  }\n}\n\nfragment Wrap_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      symbol\n      decimals\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      ...PaymentAssetMedia_asset\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0989c33d15eee5ea33f699051815bac";

export default node;
